import {
  LegalFooter,
  UiModal,
  UiModalContent,
  UiPaymentCard,
  UiLinkCard,
  UserHasDebtsModal,
  AccessToApp,
  PTmbPlannerPayment,
  TmbSummaryAmounts,
  ActivityCancelError,
  NoPromoCode,
  CancelPstError,
  UiMessage,
  TravelDiscount,
  DiscountWorth,
  RemoveDiscount,
  UiToast,
} from "libs/raas-ui-react-components/src/components";
import useSession from "hooks/useSession";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  getFooterLiterals,
  getPageLiterals,
  getPrivatePolicyLiterals,
  getUpdatedTarifModalLiterals,
  getUserHasDebtsModalLiterals,
  getErrorPayModalLiterals,
  getMessageExpiredModal,
  getPaymentMethodModalLiterals,
  getOrderFaildLiterals,
} from "./TmbResumeRoute.util";
import { formatPrice } from "../TripSelector/TripSelector.service";
import { useNavigate } from "react-router-dom";
import useToast from "hooks/useToast";
import { IBodyTripSelected } from "models/TripInterface";
import {
  defaultCard,
  deleteCard,
  getPaymentMethods,
  setNavigate,
} from "services/api/redsys.service";
import { IPaymentCardsSection } from "raas-ui-react-components/dist/types/components/pages/private/p-payment-methods/p-payment-methods.model";
import {
  getDeleteCardErrorLiterals,
  getDeleteCardLiterals,
  getGoogleApple,
  mapPaymentCards,
  typePay,
} from "../PaymentMethods/PaymentMethods.util";
import "./TmbResumeRoute.scss";

import { getUserData } from "services/user/user-micros.service";
import {
  IUserData,
  getTmbActivitySelected,
  getUserDetail,
  initDataCodePromo,
  initOffSite,
  initTMBSummaryDetail,
  setDataCodePromoSession,
  setOffSite,
  setPayCit,
  setTypeCit,
  setUserDetail,
} from "services/user/user.session.service";
import { payTmbActivity, payTmbActivityCIT } from "./TmbResumeRoute.service";
import {
  mappingTMBAnalytics,
  mappingTMBScrenNameAnalytics,
} from "services/util/dataLayerAnalytics";
import {
  getChangePaymentMethod,
  getDiscountCardLiterals,
  getDiscountNoAppliedLiterals,
  getDiscountWorthLiterals,
  getErrorPointsLiterals,
  getModalErrorMethodPaymentLiterals,
  getModalErrorPoliciestLiterals,
  getRemoveDiscountLiterals,
  getRouteDiscountLiterals,
} from "../ResumeRoute/ResumenRoute.literals";
import { getPromoCodeCall } from "../ResumeRoute/ResumeRoute.service";
import { pricesConverter } from "../AveFlow/AveFlow.util";
import { getDiscountListCall } from "../MyPoints/MyPoints.service";
import {
  calculoDescuentoPorRuta,
  updatePriceButtons,
} from "../ResumeRoute/ResumenRouteDiscounts";
import {
  getPaymentGatewayData,
  getPaymentGatewayDataTmb,
} from "../ResumeRoute/ResumeRoute.util";
import {
  getPaymentMethodsUser,
  setPaymentMethodsLocal,
} from "services/user/user.local.service";

declare const window: any;
export const TmbResumeRoute = () => {
  const { openToast } = useToast();
  const { productTMBDetails, setUserConnected } = useSession();
  const activitySelected = getTmbActivitySelected();

  const [t] = useTranslation("tmbPages");
  const [t2] = useTranslation("paymentMethodsFlow");
  const [t3] = useTranslation("tmbModals");
  const [t4] = useTranslation("discountModals");

  const literalesModalsPoints = getErrorPointsLiterals(t4);
  const [tresumeroute] = useTranslation("resumeroute");
  const navigate = useNavigate();

  const privacyPolicyLiterals = getPrivatePolicyLiterals(tresumeroute);
  const footerLiterals = getFooterLiterals(t);
  const pageLiterals = getPageLiterals(t);
  //const errorPayLiterals = getErrorPayModalLiterals(t3);
  const [errorPayLiterals, setErrorPayLiterals] = useState("" as any);
  const userHasDebtsModalLiterals = getUserHasDebtsModalLiterals(t);
  const paymentMethodModalLiterals =
    getPaymentMethodModalLiterals(tresumeroute);
  const pageLiteralsResumen = getPageLiterals(tresumeroute);

  const [discountsList, setDiscountsList] = useState([]);
  const [travelData, setTravelData] = useState({} as IBodyTripSelected);
  const [openSummaryAmounts, setOpenSummaryAmounts] = useState(false);
  const [showPrivacyPolicy, setshowPrivacyPolicy] = useState(false);
  const [showChangeCreditCard, setShowChangeCreditCard] = useState(false);
  const [privacyPolicyAccepted, setPrivacyPolicyAccepted] = useState(false);

  const [totalPrice, setTotalPrice] = useState("0,00 €");
  const [totalPriceToPay, setTotalPriceToPay] = useState("0,00 €");

  const [summaryInfo, setSummaryInfo] = useState([] as any);

  const [paymentDefault, setPaymentDefault] = useState({} as any);
  const [paymentDefaultAux, setPaymentDefaultAux] = useState({} as any);
  const [paymentMethods, setPaymentMethods] = useState([] as any);
  const [cards, setCards] = useState(
    getGoogleApple(t2, getPaymentMethodsUser()?.id) as any
  );
  const [cardNumber, setCardNumber] = useState("" as any);
  const [cardType, setCardType] = useState("" as any);
  const [showPayment, setShowPayment] = useState(true);
  const [showPaymentLiteral, setShowPaymentLiteral] = useState(true);
  const [disableButtonPay, setDisableButtonPay] = useState(true);

  const [showPaymentError, setShowPaymentError] = useState(false);

  const [showUserHasDebtsModal, setShowUserHasDebtsModal] = useState(false);
  const [showUpdateTarifModal, setShowUpdateTarifModal] = useState(false);

  const [showErrorPrivacyPolicy, setShowErrorPrivacyPolicy] = useState(false);
  const [showMethodPayment, setShowMethodPayment] = useState(false);

  const modalErrorMethodPaymentLiterals =
    getModalErrorMethodPaymentLiterals(tresumeroute);
  const modalErrorPoliciesLiterals =
    getModalErrorPoliciestLiterals(tresumeroute);

  const [showMessageExpireDateCard, setShowMessageExpireDateCard] =
    useState(false);
  const [showExpiredCardModal, setShowExpiredCardModal] = useState(false);
  const [isDefaultCardExpired, setIsDefaultCardExpired] = useState(false);
  const [cardExpireDate, setCardExpireDate] = useState("");
  const modalChangePaymentMethod = getChangePaymentMethod(t);
  const [dataCodePromo, setDataCodePromo] = useState({
    voucherCode: "",
    voucherAmount: 0,
    discountType: "DOCO",
    isValid: false,
    reset: false,
  });
  const [codeInputDiscount, setCodeInputDiscount] = useState(null);

  //Función literales modales descuento
  const discountWorthLiterals = getDiscountWorthLiterals(t4);
  const discountNoAppliedLiterals = getDiscountNoAppliedLiterals(t4);
  const removeDiscount = getRemoveDiscountLiterals(t4);
  const discountCardLiterals = getDiscountCardLiterals(t4);
  const [showModalClearDiscounts, setShowModalClearDiscounts] = useState(false);
  const [isApplyDiscount, setIsApplyDiscount] = useState(false);
  const [showModalRouteDiscount, setShowModalRouteDiscount] = useState(false);

  const [routeDiscountLiterals, setRouteDiscountLiterals] = useState({} as any);
  const [transportsDocoDiscountIda, setTransportsDocoDiscountIda] = useState(
    [] as any
  );
  const [transportsDocoDiscountVuelta, setTransportsDocoDiscountVuelta] =
    useState([] as any);

  const [currentStep, setCurrentStep] = useState(0);
  const [saveSelectedPst, setSaveSelectedPst] = useState(null as any); //se guarda el id del pst del filter transportsDocoDiscountIda y transportsDocoDiscountVuelta
  //const [saveTabs, setSaveTabs] = useState(null as any);
  //let saveTabs=null as any
  const [isOnePst, setIsOnePst] = useState(false);
  const [discount, setDiscount] = useState([] as any);

  const [showModalMajorDiscount, setShowModalMajorDiscount] = useState(false);
  const [copiedDiscountCode, setCopiedDiscountCode] = useState(false);
  const [isCheckServicePoints, setIsCheckServicePoints] = useState(true);

  let priceDiscount = 0;
  let deleteDiscount = false;
  const getOffSide = initOffSite();
  const getDataCodePromo = initDataCodePromo();

  const [showDeleteCard, setShowDeleteCard] = useState(false);
  const [cardToDelete, setCardToDelete] = useState({} as any);
  const [showDeleteCardError, setShowDeleteCardError] = useState(false);

  useEffect(() => {
    _getPayments();
    _calculateSum();
    _calculateSumToPay();
    _getDiscountsList();
    let { typeCard } = mappingTMBAnalytics(
      window.sessionStorage["raas-id-tmb-select"]
    );
    window.dataLayer?.push({
      event: "page_view",
      screen_name:
        typeCard + mappingTMBScrenNameAnalytics(productTMBDetails.title),
      screen_class: "trip_cart_resume",
      option_selected: productTMBDetails.title,
    });
  }, []);

  //Si cambia de idioma comprueba de nuevo los literales de los precios
  useEffect(() => {
    _calculateSumToPay();
  }, [t]);

  useEffect(() => {
    let cardType = "";
    let cardNumberAux = paymentDefault.number;
    //let cardTypeAux = paymentDefault?.type?.toLowerCase();

    let cardExpireDateAux = paymentDefault.expireDate;
    if (
      paymentDefault?.icon === "google_pay" ||
      paymentDefault?.icon === "apple_pay"
    ) {
      cardType = paymentDefault?.icon;
    } else {
      cardType = paymentDefault?.type?.toLowerCase();
    }
    setCardNumber(cardNumberAux);
    setCardType(cardType);
    setCardExpireDate(cardExpireDateAux);
  }, [paymentDefault]);

  /* Comprueba siempre el status de los precios y deshabilita el botón si no cumple. */
  useEffect(() => {}, [showPayment, paymentMethods]);

  const _getPayments = () => {
    getPaymentMethods().then((response: any) => {
      const paymentDefaultMethod = mapPaymentCards(
        response,
        t2,
        true,
        getPaymentMethodsUser()?.id
      ).filter((t: any) => t.default === true)[0];

      setPaymentDefault({ ...paymentDefaultMethod });
      setPaymentMethods(
        mapPaymentCards(response, t2, false, getPaymentMethodsUser()?.id)
      );
      setCards(
        mapPaymentCards(response, t2, false, getPaymentMethodsUser()?.id)
      );

      if (
        paymentDefaultMethod &&
        isExpiredDatePaymentCard(paymentDefaultMethod.expireDate)
      ) {
        setIsDefaultCardExpired(true);
        setShowExpiredCardModal(true);
      }
    });
  };
  /* METODO PARA COMPROBAR SI ACTIVAMOS BOTON O NO CUANDO LA POLITICA Y LA TARJETA SE MODIFIQUE */
  useEffect(() => {
    checkDisabledButtonPay();
  }, [privacyPolicyAccepted, paymentMethods]);

  useEffect(() => {
    //deleteDocoDiscountDesglose();
    if (getOffSide === true) {
      if (getDataCodePromo?.isValid === true) {
        setIsApplyDiscount(true);
        setDataCodePromo(getDataCodePromo);
        setTotalPrice(getDataCodePromo.totalPrice);
        setTotalPriceToPay(getDataCodePromo.totalPriceToPay);
      }
    }
  }, [deleteDiscount]);

  const _calculateSum = () => {
    setTotalPrice(productTMBDetails?.passengers?.totalPrice);
  };

  const _calculateSumToPay = () => {
    setShowPaymentLiteral(true);
    setTotalPriceToPay(productTMBDetails?.passengers?.totalPrice);
  };

  const getSelectedTariffPassenger = () => {
    const passengersList = initTMBSummaryDetail()?.passengers.passengers;
    let passengerListUpdated: any[] = [];

    if (initTMBSummaryDetail()?.id === "night-tour") {
      passengersList.forEach((element: any) => {
        if (element.counter > 0) {
          const seletectedTariffPassenger = {
            catalogueId: initTMBSummaryDetail()?.id,
            context: element.contextValue,
            //contextType: initTMBSummaryDetail()?.contextType,
            contextType: "BOOKEE_CONTEXT",
            name: productTMBDetails?.title,
            numberOfTickets: element.counter,
            provider: "tmb", //initTMBSummaryDetail()?.provider,
            catalogueItemId: activitySelected.catalogueItemId,
            providerParameters: {
              serviceDate: initTMBSummaryDetail()?.language?.serviceDate,
              languages: initTMBSummaryDetail()?.language.noMapped,
            },
          };
          passengerListUpdated.push(seletectedTariffPassenger);
        }
      });
    } else if (initTMBSummaryDetail()?.id === "xmas-tour") {
      passengersList.forEach((element: any) => {
        if (element.counter > 0) {
          const seletectedTariffPassenger = {
            catalogueId: initTMBSummaryDetail()?.id,
            context: element.contextValue,
            contextType: "BOOKEE_CONTEXT",
            name: productTMBDetails?.title,
            numberOfTickets: element.counter,
            provider: "tmb", //initTMBSummaryDetail()?.provider,
            catalogueItemId: activitySelected.catalogueItemId,
            providerParameters: {
              serviceDate: initTMBSummaryDetail()?.language?.serviceDate,
              languages: initTMBSummaryDetail()?.language.noMapped,
            },
          };
          passengerListUpdated.push(seletectedTariffPassenger);
        }
      });
    } else {
      passengersList.forEach((element: any) => {
        if (element.counter > 0) {
          const seletectedTariffPassenger = {
            catalogueId: initTMBSummaryDetail()?.id,
            context: element.contextValue,
            contextType: initTMBSummaryDetail()?.contextType,
            //contextType: "BOOKEE_CONTEXT",
            name: productTMBDetails?.title,
            numberOfTickets: element.counter,
            provider: initTMBSummaryDetail()?.provider,
            catalogueItemId: activitySelected.catalogueItemId,
          };
          passengerListUpdated.push(seletectedTariffPassenger);
        }
      });
    }

    return passengerListUpdated;
  };

  const nextPage = () => {
    // privacyPolicyAccepted ? _getMyProfileInfo(): setshowPrivacyPolicy(true);

    let { typeCard } = mappingTMBAnalytics(
      window.sessionStorage["raas-id-tmb-select"]
    );
    window.dataLayer?.push({
      event: "page_view",
      screen_name:
        typeCard + mappingTMBScrenNameAnalytics(productTMBDetails.title),
      screen_class: "trip_cart_resume",
      content_name: "pay_TMB",
      content_type: "button",
      option_selected: productTMBDetails.title,
    });

    /*if (!privacyPolicyAccepted) {
			setshowPrivacyPolicy(true);
			return;
		}*/

    if (disableButtonPay === true) {
      setShowMethodPayment(true);
    } else {
      if (privacyPolicyAccepted) {
        let selectedCard = cards.find((card: any) => card.selected);
        if (selectedCard && isExpiredDatePaymentCard(selectedCard.expireDate)) {
          setIsDefaultCardExpired(true);
          setShowExpiredCardModal(true);
        } else {
          let paymentTmbActivity = {
            paymentMethodId:
              showPayment &&
              (paymentDefault.id === typePay.GOOGLE ||
                paymentDefault.id === typePay.APPLE ||
                paymentDefault.id === typePay.XPAY)
                ? ""
                : paymentDefault.id,
            ...(paymentDefault.id === typePay.GOOGLE ||
            paymentDefault.id === typePay.APPLE||
                paymentDefault.id === typePay.XPAY
              ? { paymentMethod: paymentDefault.id }
              : {}),
            outwardJourney: {
              activity: {
                details: activitySelected?.description?.details,
                url: activitySelected?.url,
                extras: discount,
              },
              selectedTariff: getSelectedTariffPassenger(),
            },
            travellers: [
              {
                type: "ADULT",
              },
            ],
          };
          payTmbActivityCIT(
            paymentTmbActivity,
            (response: any) => {
              const {
                url,
                Ds_SignatureVersion,
                Ds_Signature,
                Ds_MerchantParameters,
              } = getPaymentGatewayDataTmb(response);
              setPayCit({
                url: url,
                Ds_SignatureVersion: Ds_SignatureVersion,
                Ds_Signature: Ds_Signature,
                Ds_MerchantParameters: Ds_MerchantParameters,
              });
              setTypeCit("tmb");
              navigate(`/redsys:payCitTmb`);
              //navigate("/tmb-confirm-planning");
            },
            (err: any) => {
              //Order fail
              const isOrderFail = err?.data?.errors?.[0]?.code?.includes("014");
              if (isOrderFail) {
                setErrorPayLiterals(getOrderFaildLiterals(tresumeroute, t3));
                setShowPaymentError(true);
              } else {
                setErrorPayLiterals(getErrorPayModalLiterals(t3));
                setShowPaymentError(true);
              }
            }
          );
        }
      } else {
        setShowErrorPrivacyPolicy(true);
      }
    }
  };

  const handleCreditCardChange = () => {
    setShowChangeCreditCard(true);
  };

  const handleAddCreditCard = () => {
    setOffSite(true);
    setDataCodePromoSession({
      ...dataCodePromo,
      totalPrice: totalPrice,
      totalPriceToPay: totalPriceToPay,
    });
    setShowChangeCreditCard(false);
    setNavigate("/app/tmb-resume-route");
    navigate(`/redsys:addCard?goTo=/app/tmb-resume-route`);
  };

  const isExpiredDatePaymentCard = (expiredDate: string) => {
    const currentDate = new Date();
    const expireDate = new Date(expiredDate);

    return expireDate < currentDate;
  };

  const handleSelectCard = () => {
    let selectedCard = cards.find((card: any) => card.selected);

    if (selectedCard && isExpiredDatePaymentCard(selectedCard.expireDate)) {
      setIsDefaultCardExpired(true);
      setShowMessageExpireDateCard(true);
      return;
    }

    if (
      selectedCard.id !== paymentDefault.id &&
      selectedCard.number !== typePay.GOOGLE &&
      selectedCard.number !== typePay.APPLE &&
      selectedCard.number !== typePay.XPAY
    ) {
      const id = selectedCard.id;
      const body = {
        defaultPaymentMethod: "true",
      };
      defaultCard(id, body)
        .then((response: any) => {
          window.sessionStorage.removeItem("raas-payment-methods");
        })
        .catch((error: any) => {
          openToast("error", t("literals.title"), t("literals.errorSaving"));
        });
    } else {
      let valueUserDetail = getUserDetail().email;

      setPaymentMethodsLocal({
        id: selectedCard.id,
        email: valueUserDetail,
      });
    }
    setIsDefaultCardExpired(false);
    setPaymentDefault(paymentDefaultAux);
    setShowChangeCreditCard(false);
  };

  const handleUpdateModal = () => {
    setShowUpdateTarifModal(false);
    navigate("/plan");
  };

  const handleClickCard = (ev: CustomEvent) => {
    setShowMessageExpireDateCard(false);
    let id = ev.detail;
    let aux: any[] = [];
    cards.forEach((el: IPaymentCardsSection) => {
      if (el.id === id) {
        el.selected = true;
        setPaymentDefaultAux(el);
      } else {
        el.selected = false;
      }
      aux.push(el);
    });
    setCards([...aux]);
  };

  const _createTrip = () => {
    // Antes de crear el trip hay que revisar las tarifas RAASWEB-708
  };

  const checkTarifsAreAvailable = (callback: Function) => {
    callback();
  };

  const _userWithDebtsFlow = () => {
    setShowUserHasDebtsModal(true);
  };

  const _checkIfIsBoolean = (customerAllowed: string | boolean): boolean => {
    return typeof customerAllowed == "boolean";
  };
  const _getCustomerAllowedStatus = (
    customerAllowedValue: string | boolean,
    userDataResponse: IUserData
  ) => {
    return _checkIfIsBoolean(customerAllowedValue)
      ? customerAllowedValue
      : userDataResponse?.payment?.customerAllowed === "true";
  };

  //Metodo onClick del boton de pagar
  const _getMyProfileInfo = () => {
    continuePayment();
  };

  const _checkIfUserHasDebts = (userDataResponse: IUserData): void => {
    const customerAllowedValue = userDataResponse?.payment?.customerAllowed;
    const customerAllowed = !!customerAllowedValue
      ? _getCustomerAllowedStatus(customerAllowedValue, userDataResponse)
      : false;
    customerAllowed ? _createTrip() : _userWithDebtsFlow();
  };

  const backPage = () => {
    let data = initTMBSummaryDetail();
    const path =
      data?.id === "night-tour" ? "/tmb-night-bus-flow" : "/tmb-normal-flow";
    const fromResume = true;
    navigate(path, { state: { fromResume } });
  };

  /**
   * Metodo para comprobar si activamos el boton o no
   */
  const checkDisabledButtonPay = () => {
    if (/*privacyPolicyAccepted==true && */ paymentMethods.length != 0) {
      setDisableButtonPay(false);
    } else {
      setDisableButtonPay(true);
    }
  };

  //Servicio de pagar
  const continuePayment = () => {
    getUserData(
      (response: any) => {
        const userDataResponse = response?.data;
        setUserDetail(userDataResponse);
        setUserConnected(userDataResponse);
        _checkIfUserHasDebts(userDataResponse);
      },
      () => {
        openToast(
          "error",
          t("literals.error"),
          t("literals.errorTryAgainLater")
        );
      }
    );
  };

  const paymentCards = () => {
    return (
      <div className="row">
        {cards?.map((card: IPaymentCardsSection) => {
          return (
            <div key={card.id} className="col-sm-12 card-margin">
              <UiPaymentCard
                onNavigateToEvent={handleClickCard}
                href-link={card.id}
                disabled={false}
                selected={card.selected}
                card-top-text={card.type}
                card-bottom-text={"**** " + card.number}
                icon-left-type={card.icon}
                card-bottom-sub-text={card.expireDate}
                icon-right-type="delete_icon"
                class-type={undefined}
                expired-text={modalChangePaymentMethod.stateCard}
                onRightCardClick={handleDeleteCheck}
              ></UiPaymentCard>
            </div>
          );
        })}
      </div>
    );
  };

  const cardsLinksSection = () => {
    return (
      <div className="row">
        <div className="col-sm-12 card-margin">
          <UiLinkCard
            onNavigateToEvent={handleAddCreditCard}
            href-link={"path"}
            disabled={false}
            card-text={t2("literals.addCreditDebitCard")}
            icon-type={"pay"}
          ></UiLinkCard>
        </div>
      </div>
    );
  };

  /////////////////////BLOQUE DESCUENTOS///////////////////////////////
  /**
   * Funcion que comprueba si el codigo es valido
   * @param value codigo
   */
  const checkPromoCode = (value: any) => {
     let formatDecimal = formatDecimalPrice(
      productTMBDetails?.passengers?.totalPrice
    ) as any;
    let body = {
      voucherCode: value?.voucherCode,
      discountType: "DOCO",
      provider: "TMB",
      purchaseAmount: pricesConverter(formatDecimal),
    };
    setCodeInputDiscount(value?.voucherCode);
    getPromoCodeCall(
      body,
      (response: any) => {
        if (response.data.isValid === false) {
          setDataCodePromo({
            voucherCode: response.data.voucherCode,
            voucherAmount: response.data.voucherAmount,
            discountType: response.data.discountType,
            isValid: false,
            reset: false,
          });
        } else {
          setDataCodePromo({
            voucherCode: response.data.voucherCode,
            voucherAmount: response.data.voucherAmount,
            discountType: response.data.discountType,
            isValid: true,
            reset: false,
          });
        }
      },
      (err: any) => {
        openToast(
          "error",
          tresumeroute("literals.error"),
          tresumeroute("literals.errorTryAgainLater")
        );
      },
      window.sessionStorage["raas-trip-mock"]
    );
  };

  const openModalDiscount = () => {
    let formatDecimal = formatDecimalPrice(
      productTMBDetails?.passengers?.totalPrice
    ) as any;
    let transportsIda = [
      {
        bonoAveFree: false,
        color: "#FFFFFF",
        icon: "TMB",
        idLeg: "0",
        idTariff: 0,
        informative: false,
        isIncluding: false,
        key: "departure",
        line: "TMB",
        price: pricesConverter(formatDecimal),
        route: "TMB",
        transport: "TMB",
      },
    ] as any;
    let transportsVuelta = [] as any;

    setTransportsDocoDiscountIda(transportsIda);
    setTransportsDocoDiscountVuelta(transportsVuelta);
    setRouteDiscountLiterals(getRouteDiscountLiterals(tresumeroute));

    //Comprobamos si hay mas de un viaje, si solo hay un viaje saltamos directamente al paso 1 (meter el codigo)
    if (
      transportsIda.length === 1 &&
      (transportsVuelta == undefined || transportsVuelta.length === 0)
    ) {
      setCurrentStep(1);
      setSaveSelectedPst(transportsIda[0]);
      setIsOnePst(true);
    } else if (transportsIda.length === 0 && transportsVuelta.length === 1) {
      setCurrentStep(1);
      setSaveSelectedPst(transportsVuelta[0]);
      setIsOnePst(true);
    }
    setShowModalRouteDiscount(true);
  };

  const applyDocoDiscount = (e: any) => {
    priceDiscount = dataCodePromo.voucherAmount / 100;
    let formatDecimal = formatDecimalPrice(
      productTMBDetails?.passengers?.totalPrice
    ) as any;

    const priceTrip = pricesConverter(formatDecimal);
    setCodeInputDiscount(null);

    if (priceDiscount > priceTrip) {
      setShowModalRouteDiscount(false); //cerramos el modal de escribir código
      setShowModalMajorDiscount(true);
    } else {
      //Cuando es IDA
      if (e.tabs === "tab1") {
        applyDiscountMoreRoute();
      }
    }
  };

  const applyDiscountMoreRoute = () => {
    let formatDecimal = formatDecimalPrice(
      productTMBDetails?.passengers?.totalPrice
    ) as any;
    const priceTrip = pricesConverter(formatDecimal);
    let getPriceButton = priceTrip;
    let getPriceTotal = priceTrip;
    let getTotal = priceTrip;
    let totalTrip;

    let discountToApply = 0;
    discountToApply = calculoDescuentoPorRuta(
      priceTrip,
      dataCodePromo.voucherAmount / 100
    ); //+ priceStringToNumber(getReturn) as any
    let { priceTotal, priceButton } = updatePriceButtons(
      discountToApply,
      getPriceTotal,
      getPriceButton,
      priceTrip,
      dataCodePromo.voucherAmount / 100,
      false,
      formatDecimal,
      false
    );
    totalTrip = priceTotal;

    getPriceTotal = priceTotal;
    getPriceButton = priceButton;

    //Funcion donde añadimos el objeto del descuento desglose
    setTotalPrice((getPriceButton * 100) as any);
    setTotalPriceToPay((getPriceButton * 100) as any);
    setShowModalMajorDiscount(false); //????
    setShowModalRouteDiscount(false);
    setIsApplyDiscount(true);
    setDiscount([
      {
        amount: dataCodePromo.voucherAmount / 100,
        value: dataCodePromo.voucherCode,
        discountType: dataCodePromo.discountType,
        type: "DISCOUNT",
      },
    ]);
  };

  const formatDecimalPrice = (price: any) => {
    try {
      const newPrice = (price / 100).toLocaleString(undefined, {
        minimumFractionDigits: 2,
      });
      return newPrice;
    } catch (error) {
      console.log("formatDecimalPrice");
    }
  };
  /*
   * Funcion donde quitamos el descuento
   * @param e
   */
  const deleteDocoDiscount = () => {
    setIsApplyDiscount(false);
    setDataCodePromo({
      voucherCode: "",
      voucherAmount: 0,
      discountType: "DOCO",
      isValid: false,
      reset: false,
    });
    setDiscount([]);
    setTotalPrice(productTMBDetails?.passengers?.totalPrice);
    setTotalPriceToPay(productTMBDetails?.passengers?.totalPrice);
  };

  /////////////////////BLOQUE DESCUENTOS///////////////////////////////

  const handleGoMyPoints = () => {
    setNavigate("/app/tmb-resume-route");
    navigate(`/my-points?goTo=/app/tmb-resume-route`);
  };

  const _getDiscountsList = () => {
    getDiscountListCall(
      (response: any) => {
        if (response.length != 0) {
          setDiscountsList(response);
        } else {
          setDiscountsList([]);
        }

        setIsCheckServicePoints(false);
      },
      (err: any) => {
        setIsCheckServicePoints(true);
        if (!err.status) {
          console.warn("Ha ocurrido un error", err);
        }
        if (err && err.status !== 401) {
          // openToast("error", t("literals.errorRequest"), `${err?.status ? ':' + err?.status : ''} ${err?.statusText}`)
        } else if (err && err[0] && err[0].code) {
          // openToast("error", t("literals.errorRequest"), `${err[0].code ? ':' + err[0].code : ''} ${err[0].message}`)
        }
      },
      window.sessionStorage["raas-trip-mock"]
    );
  };

  const handleDeleteCard = () => {
    deleteCard(cardToDelete)
      .then(() => {
        const cardDeleted = cards.find((el: any) => el.id === cardToDelete);
        const isDeleteCardSelected = cardDeleted && cardDeleted.selected;
        let aux = cards.filter((el: any) => el.id != cardToDelete);
        if (
          isDeleteCardSelected &&
          aux.find((o: any) => new Date(o.expireDate) > new Date())
        ) {
          aux.find((o: any) => new Date(o.expireDate) > new Date()).selected =
            true;
        }
        setCards(aux);
        setShowDeleteCard(false);
      })
      .catch((error: any) => {
        setShowDeleteCardError(true);
      });
  };

  const handleCloseModal = (ev: CustomEvent) => {
    setShowDeleteCard(false);
  };
  const handleCloseModalError = (ev: CustomEvent) => {
    setShowDeleteCardError(false);
  };
  const handleDeleteCheck = (ev: CustomEvent) => {
    setCardToDelete(ev.detail);
    setShowDeleteCard(true);
  };

  return (
    <>
      <PTmbPlannerPayment
        show-payment-component={showPayment}
        summary={productTMBDetails}
        literals={pageLiterals}
        creditCardNumber={cardNumber}
        creditCardType={cardType}
        onChangeCardEvent={handleCreditCardChange}
        onAddCardEvent={() => setShowChangeCreditCard(true)}
        total={totalPrice}
        totalToPay={totalPriceToPay}
        showPaymentLiteral={showPaymentLiteral}
        onOpenSummaryEvent={() => setOpenSummaryAmounts(true)}
        privacy-policy-status={privacyPolicyAccepted}
        onMoreinfoTcEvent={() => setshowPrivacyPolicy(true)}
        onAcceptTcEvent={(e) => {
          setPrivacyPolicyAccepted(e.detail);
          setshowPrivacyPolicy(false);
        }}
        onNextPage={() => nextPage()}
        onBackPage={() => backPage()}
        disable-pay-button={disableButtonPay}
        cardTMB={activitySelected}
        show-privacy-policy={showPrivacyPolicy}
        creditCardExpireDate={cardExpireDate}
        isDefaultCardExpired={isDefaultCardExpired}
        onShowMessageModalEvent={() => setShowMessageExpireDateCard(true)}
        onAddDiscountEvent={() => openModalDiscount()}
        dataCodePromo={dataCodePromo}
        onCheckPromoCode={(e) => checkPromoCode(e.detail as String)}
        //onApplyDocoDiscount={(e) => applyDocoDiscount(e.detail)}
        literalesModaRemoveDiscount={removeDiscount}
        discountCardLiterals={discountCardLiterals}
        onShowModalClearDiscountsEvent={() => setShowModalClearDiscounts(true)}
        applyDiscount={isApplyDiscount}
      ></PTmbPlannerPayment>
      <UiToast
        visible={copiedDiscountCode}
        textTitle={
          pageLiteralsResumen.promoCode?.discountsAvailable.toast.title
        }
        textDesc={
          pageLiteralsResumen.promoCode?.discountsAvailable.toast.subtitle
        }
        type="success"
        onHandleClickToast={() => setCopiedDiscountCode(false)}
      ></UiToast>

      <div className="mt-80">
        <UiModal open={openSummaryAmounts} blockOverlay={true}>
          <TmbSummaryAmounts
            literals={pageLiterals.desgloseModal}
            activity={productTMBDetails as any}
            onCloseSummaryAmountsEvent={() => setOpenSummaryAmounts(false)}
            discountData={dataCodePromo}
          />
        </UiModal>
        <UiModal open={showChangeCreditCard} blockOverlay={true}>
          <UiModalContent
            onCloseModal={() => setShowChangeCreditCard(false)}
            onOkModal={handleSelectCard}
            literals={paymentMethodModalLiterals}
          >
            <div className="row-cards-container scrollbar">
              <div className="mb-4">
                <UiMessage
                  show={showMessageExpireDateCard}
                  literal={{
                    maintext: paymentMethodModalLiterals.expirationWarningText,
                  }}
                  type="error"
                ></UiMessage>
              </div>
              {paymentMethods?.length > 0 && paymentCards()}
              {cardsLinksSection()}
            </div>
          </UiModalContent>
        </UiModal>
        <UiModal open={showExpiredCardModal} blockOverlay={true}>
          <CancelPstError
            literals={getMessageExpiredModal(t)}
            onClickCancelPstErrorButton={() => setShowExpiredCardModal(false)}
          ></CancelPstError>
        </UiModal>
        {/* Modal cuando no hay metodo de pago añadido */}
        <UiModal open={showMethodPayment} blockOverlay={true}>
          <NoPromoCode
            nameImage={"no_results"}
            literals={modalErrorMethodPaymentLiterals}
            onClickOkButton={() => setShowMethodPayment(false)}
          />
        </UiModal>

        {/* Modal cuando no esta aceptadas la politicas */}
        <UiModal open={showErrorPrivacyPolicy} blockOverlay={true}>
          <NoPromoCode
            nameImage={"no_results"}
            literals={modalErrorPoliciesLiterals}
            onClickOkButton={() => {
              setshowPrivacyPolicy(true);
              setShowErrorPrivacyPolicy(false);
            }}
          />
        </UiModal>

        <UiModal
          open={showModalRouteDiscount}
          nopadding={true}
          blockOverlay={true}
        >
          <TravelDiscount
            literals={routeDiscountLiterals}
            outwardTripInfo={transportsDocoDiscountIda}
            returnTripInfo={transportsDocoDiscountVuelta}
            currentStep={currentStep}
            dataCodePromo={dataCodePromo}
            literalesModaRemoveDiscount={removeDiscount}
            codeInputDiscount={codeInputDiscount}
            isOnePst={isOnePst}
            isCheckServicePoints={isCheckServicePoints}
            discountsList={discountsList}
            literalesModalsPoints={literalesModalsPoints}
            onCodeInputDiscountEmit={(e) => setCodeInputDiscount(e.detail)}
            onHandleApplyDiscounts={(e) => {
              applyDocoDiscount(e.detail);
            }}
            onCloseTravelDiscountModal={() => {
              setCodeInputDiscount(null);
              setShowModalRouteDiscount(false);
              setCurrentStep(0);
              setDataCodePromo({
                voucherCode: "",
                voucherAmount: 0,
                discountType: "DOCO",
                isValid: false,
                reset: false,
              });
            }}
            onHandleTravelsDiscount={(e) => {
              setSaveSelectedPst(e?.detail);
              setCurrentStep(1);
            }} //Guardamos el viaje marcado y pasamos de step
            onCheckPromoCode={(e) => checkPromoCode(e.detail as String)}
            onShowToastCodePromo={() => setCopiedDiscountCode(true)}
            onGoMyPointsEvent={() => handleGoMyPoints()}
          />
        </UiModal>
        <UiModal open={showUserHasDebtsModal} blockOverlay={true}>
          <UserHasDebtsModal
            literals={userHasDebtsModalLiterals}
            onConfirmButtonEvent={() => setShowUserHasDebtsModal(false)}
          ></UserHasDebtsModal>
        </UiModal>
        {/* Modales desceunto Doco  DESCUENTO MAYOR*/}
        <UiModal open={showModalMajorDiscount} blockOverlay={true}>
          <DiscountWorth
            literals={discountWorthLiterals}
            onCancelModal={() => {
              setShowModalMajorDiscount(false);
              setDataCodePromo({
                voucherCode: "",
                voucherAmount: 0,
                discountType: "DOCO",
                isValid: false,
                reset: false,
              });
            }}
            onOkModal={() => applyDiscountMoreRoute()}
          />
        </UiModal>
        <UiModal open={showUpdateTarifModal} blockOverlay={true}>
          <AccessToApp
            literals={JSON.stringify(getUpdatedTarifModalLiterals(t))}
            onCancelModal={() => setShowUpdateTarifModal(false)}
            onOkModal={() => handleUpdateModal()}
          />
        </UiModal>
        <LegalFooter literals={footerLiterals}></LegalFooter>
      </div>
      <UiModal open={showPaymentError} blockOverlay={true} nopadding>
        <ActivityCancelError
          literals={errorPayLiterals}
          onOkButton={(ev: any) => setShowPaymentError(false)}
        ></ActivityCancelError>
      </UiModal>

      {/* Modal para eliminar descuento aplicado */}
      <UiModal open={showModalClearDiscounts} blockOverlay={true}>
        <RemoveDiscount
          onOkModal={() => {
            deleteDocoDiscount();
            setShowModalClearDiscounts(false);
          }}
          literals={removeDiscount}
          onCancelModal={() => setShowModalClearDiscounts(false)}
        />
      </UiModal>

      {/* Modal de avis ode borrado de tarjeta*/}
      <UiModal open={showDeleteCard} blockOverlay={true}>
        <AccessToApp
          literals={JSON.stringify(getDeleteCardLiterals(t2))}
          onCancelModal={handleCloseModal}
          onOkModal={handleDeleteCard}
        />
      </UiModal>
      {/* Error deleting */}
      <UiModal open={showDeleteCardError} blockOverlay={true}>
        <AccessToApp
          literals={JSON.stringify(getDeleteCardErrorLiterals(t2))}
          onCancelModal={handleCloseModalError}
          onOkModal={handleDeleteCard}
        />
      </UiModal>
    </>
  );
};
